/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SeriesRepetitionEnum } from './seriesRepetitionEnum';
import { AppointmentBlockerType } from './appointmentBlockerType';


import {ValidatorFn, Validators} from "@angular/forms";

export interface CalendarBlockerInitial { 
    blockerTypes: Array<AppointmentBlockerType>;
    readonly repetitionTypes: Array<SeriesRepetitionEnum>;
}
export const CalendarBlockerInitial_blockerTypes_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CalendarBlockerInitial_repetitionTypes_Validators: ValidatorFn[] =
    [  Validators.required, ];


